<template lang="pug">
div
  v-icon(color="darkGrey", :size="16", v-if="!hideIcon" ) {{ timeIcon }}
  span.pl-1.pl-sm-2(:style="styles" :title="formattedTimestamp") {{ relativeFromNow }}
</template>

<script lang="ts">
import Vue from "vue"
import { mdiClockOutline } from "@mdi/js"
import THEME from "../../constants/theme"
import moment from "moment"
const { fontFamily } = THEME.typography
moment.locale("de")

export default Vue.extend({
  name: "RelativeTime",
  props: {
    dateTime: { type: [String, Date], required: true },
    hideIcon: { type: Boolean, default: false },
  },
  data() {
    return {
      timeIcon: mdiClockOutline,
    }
  },
  computed: {
    isXsScreenSize(): boolean {
      return this.$vuetify.breakpoint.name === "xs"
    },
    styles(): object {
      return {
        color: this.$vuetify.theme.themes.light.darkGrey,
        fontWeight: 400,
        fontFamily: fontFamily,
        fontSize: `${this.isXsScreenSize ? 0.75 : 0.8}rem`,
      }
    },
    relativeFromNow(): string {
      return `${moment(this.dateTime.toString()).fromNow()}`
    },
    formattedTimestamp(): string {
      return (
        moment(this.dateTime.toString()).format("DD.MM.YYYY, HH:mm") + " Uhr"
      )
    },
  },
})
</script>
